<div
  (click)="isOpenChange.emit(!isOpen())"
  [class.burger--centered]="centered()"
  [class.burger--normal]="size() === 'NORMAL'"
  [class.burger--open]="isOpen()"
  [class.burger--with-text]="withText()"
  class="burger">
  <span [style.background-color]="color() | color"></span>
  <span [style.background-color]="color() | color"></span>
  @if (withText()) {
    <span [style.color]="color() | color">MENU</span>
  }
</div>
